import React from "react";
import { FieldRenderProps } from "react-final-form";

import { Input } from "reactstrap";
import { InputType } from 'reactstrap/lib/Input'

const TextInput: React.FC<FieldRenderProps<any, HTMLElement>> = ({
  input,
  width,
  placeholder,
  autoComplete,
  className,
  readOnly,
  meta: { touched, error },
  min,
  max
}) => {
  return (
    <Input
      {...input}
      className={className}
      placeholder={placeholder}
      type={input.type as InputType}
      autoComplete={autoComplete}
      readOnly={readOnly}
      min={min} max={max}
    />
  );
};

export default TextInput;
